import jwtAuthAxios from "@jumbo/services/auth/jwtAuth";
const authServices = {};

authServices.getCurrentUser = async () => {
  const { data } = await jwtAuthAxios.get("/auth");
  return data;
};

//loginCreds must be {email: "abc@example.com", password: "ABC123DEF"}
authServices.signIn = async (loginCreds) => {
  //const { data } = await jwtAuthAxios.post('/auth', loginCreds);
  let data = { token: "", status: false };
  if (
    loginCreds.email == "demo@example.com" &&
    loginCreds.password == "ABC123DEF"
  ) {
    data = { token: "0123456789", status: true };
  }

  return data;
};

export default authServices;
